import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ModalTemplateComponent,
  PencilModalSizeEnum,
} from '../modal-template/modal-template.component';
import {
  PencilButtonActionConfig,
  PencilButtonComponent,
} from '../../pencil-button/pencil-button.component';
import { IconConfig, PencilIconComponent } from '../../pencil-icon/pencil-icon.component';
import { ShellDialogBase, ShellDialogData } from '../shell-dialog-base';

export enum GraphicModalVariantEnum {
  ICON = 'icon',
  IMAGE = 'image',
}

/** Edge-to-edge hero image, 320:240 aspect, clipped to the card's corners. */
export interface GraphicModalBleedImageConfig {
  url: string;
  alt?: string;
}

export enum GraphicModalCloseResultEnum {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  CLOSE = 'close',
}

// The secondary button's theme is always "secondary-outline", so `danger` would do nothing here.
export type GraphicModalSecondaryButtonConfig = Omit<PencilButtonActionConfig, 'danger'>;

export interface GraphicModalData extends ShellDialogData {
  title: string;
  /** Which of `icon` / `bleedImage` is populated — unset means no graphic at all. Contained/
   *  centered, 100px default (see --graphic-modal-icon-width/height in graphic-modal.component.scss). */
  imageVariant?: GraphicModalVariantEnum;
  icon?: IconConfig;
  bleedImage?: GraphicModalBleedImageConfig;
  primaryButtonConfig: PencilButtonActionConfig;
  secondaryButtonConfig?: GraphicModalSecondaryButtonConfig;
}

const GRAPHIC_MODAL_DEFAULTS: Partial<GraphicModalData> = {
  dismissable: true,
  size: PencilModalSizeEnum.MEDIUM,
};

@Component({
  selector: 'app-graphic-modal',
  standalone: true,
  imports: [CommonModule, ModalTemplateComponent, PencilButtonComponent, PencilIconComponent],
  templateUrl: './graphic-modal.component.html',
  styleUrls: ['./graphic-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GraphicModalComponent extends ShellDialogBase<
  GraphicModalComponent,
  GraphicModalData,
  GraphicModalCloseResultEnum
> {
  graphicModalVariantEnum = GraphicModalVariantEnum;
  graphicModalCloseResultEnum = GraphicModalCloseResultEnum;

  constructor(
    dialogRef: MatDialogRef<GraphicModalComponent, GraphicModalCloseResultEnum>,
    @Inject(MAT_DIALOG_DATA) matDialogData: GraphicModalData,
  ) {
    super(dialogRef, matDialogData, GRAPHIC_MODAL_DEFAULTS);
  }
}
